




















import { Component, Vue, Prop, Model } from "vue-property-decorator";

@Component
export default class ComboBox extends Vue {
  @Model("change") readonly option!: any;
  @Prop({ default: [] }) readonly options!: Array<{ id: any; value: string }>;
  @Prop({ default: false }) readonly fullWidth?: boolean;
  @Prop({ default: null }) readonly defaultID?: any;

  open = false;
  selectedOption: { id: any; value: string } = {
    id: null,
    value: "Escolha uma opção"
  };

  handleSelected(item: { id: any; value: string }) {
    this.selectedOption = item;
    this.$emit("change", item);
  }

  mounted() {
    if (this.defaultID && this.options.length > 0) {
      this.selectedOption = this.options.find(
        op => op.id === this.defaultID
      ) ?? {
        id: null,
        value: "Escolha uma opção"
      };
    }
  }
}
